<template>
    <v-container fluid fill-height>
        <v-layout style="display: block;">
            <announcements-index/>
        </v-layout>
    </v-container>
</template>
<script>
    import AnnouncementsIndex from "../../components/admin/MainDashboard/Announcements/AnnouncementsIndex";
    export default  {
        components: {
            AnnouncementsIndex,
        }
    }
</script>